module.exports = require("@graphistry/falcor-path-utils/lib/toPaths");


//////////////////
// WEBPACK FOOTER
// external "@graphistry/falcor-path-utils/lib/toPaths"
// module id = 105
// module chunks = 0